<template>
    <div class="section">
        <div class="tile is-ancestor">
            <div class="tile is-parent">
                <div class="tile is-child box">
                    <form :action="formAction">
                        <b-loading :active="loading"></b-loading>
                        <b-message v-if="sended.message" :type="sended.type" has-icon>
                            <p v-text="sended.message" class="mb-2"></p>
                        </b-message>
                        <input type="hidden" name="_method" value="PATCH" />
                        <input type="hidden" name="entity" :value="entityType" />
                        <div class="columns">
                            <div class="column">
                                <p class="subtitle">{{componentTitle}}</p>
                            </div>
                            <div class="column is-narrow">
                                <b-button v-if="canShow(buttonVisibility) && isMultipleButton()"
                                          v-for="(button, index) in buttons" :key="index" :tag="button.buttonTag"
                                          size="is-small" class="clear form-buttons" :type="button.buttonType"
                                          :href="button.buttonAction" :native-type="button.buttonNativeType"
                                          @click.prevent="submit(button.buttonTag, button.buttonAction)"
                                          :icon-left="button.buttonIcon" :label="button.buttonLabel">
                                </b-button>
                            </div>
                        </div>
                        <table class="table is-narrow is-fullwidth">
                            <tr v-for="(status, permissionCode) in entity">
                                <td class="has-text-weight-bold" align="left" :key="permissionCode"
                                    v-text="permissionCode">
                                </td>
                                <td class="has-text-weight-bold" align="right" :key="'index_'+permissionCode">
                                    <b-button size="is-small"
                                              v-model="input[permissionCode]"
                                              v-bind:type="input[permissionCode]? 'is-success' : 'is-danger'"
                                              v-bind:label="input[permissionCode] ? 'Enabled' : 'Disabled'">
                                    </b-button>
                                </td>
                                <td v-if="canShow(showActionList)"
                                    class="has-text-weight-bold" align="right" :key="permissionCode + '-' + status" >
                                    <b-switch v-model="input[permissionCode]" :name="permissionCode"></b-switch>
                                </td>
                            </tr>
                        </table>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            entity: {
                type: Object,
                required: true
            },
            buttons: {
                type: Array
            },
            formAction: String,
            entityType: String,
            componentTitle: String,
            buttonAction: String,
            buttonLabel: String,
            buttonIcon: String,
            buttonType: String,
            buttonTag: String,
            buttonNativeType: String,
            buttonVisibility: [String, Number, Boolean],
            showActionList: [String, Number, Boolean],
        },
        data() {
            return {
                input: {},
                sended: {
                    message: "",
                    type: 'is-success'
                },
                loading: false
            }
        },
        created() {
            for (let key of Object.keys(this.entity)) {
                this.input[key] = this.entity[key];
            }
        },
        methods: {
            log(message) {
                console.log(message);
            },
            canShow(visibility) {
                return Boolean(visibility !== "false");
            },
            isMultipleButton() {
                return !!this.buttons.length;
            },
            submit(buttonTag, buttonAction) {
                if (buttonTag === "a") {
                    window.location.href = buttonAction;
                }else{
                    this.loading = true;
                    this.input['entity'] = this.entityType;
                    axios
                        .patch(this.formAction, this.input)
                        .then(result => {
                            this.sended.message = result.data.msg;
                            this.sended.type = 'is-' + result.data.type;
                            this.loading = false;
                            // window.location.href =
                            //     "http://tesshub.test/dashboard/source/index";
                            //this.$router.push({ name: "source" });
                        })
                        .catch(error => {
                            this.errors = error.response.data.errors;
                            this.loading = false;
                        });
                }


            }
        }
    }
</script>
